<template>
  <div class="loadingpoup white on">
    <div class="lds-ellipsis">資料讀取中，請稍等<div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "loading",
};
</script>


// WEBPACK FOOTER //
// src/components/includes/loading.vue